<template>
    <div class="pl-6">
      <div class="all">
        <br />
        <v-alert
            dense
            text
            type="success"
            dismissible
            close-icon="mdi-delete"
            v-if="mostrar_alerta"
            >Se enviaron las solicitudes a autorización</v-alert
        >

        <v-alert
            dense
            text
            type="error"
            dismissible
            close-icon="mdi-delete"
            v-model="mostrar_error"
            >{{ error_multiple }}</v-alert
        >
        <v-row class="mt-5">
    
          <v-col cols="12" sm="2"><v-btn @click="addsolicitud">Agregar Solicitud</v-btn></v-col>
        
        </v-row>
        
        <div class="form-group row" style="margin-top: 45px; text-align: end;">
            <h4 style="color: #1C2546">Agregar gastos</h4>
        </div>
        <v-row>
        <v-col cols="12" sm="2" md="2">
             
            </v-col>
          </v-row>
        <v-row v-if="true">
          <div class="mr-10"><h5>Descripción del viaje:</h5></div>
          <div>
            <v-text-field v-model="nombre_grupo"></v-text-field>
          </div>

        </v-row>
        <div class="fila-container">
          <div class="fila fila-title">
            <div class="column-title first">#</div>
            <div class="column-title">Tipo Solicitud</div>
            <div class="column-title">XML Factura</div>
            <div class="column-title">PDF Comprobación</div>
            <div class="column-title">Fecha Solicitud</div>
            <div class="column-title">Numero Factura</div>
            <div class="column-title">Importe</div>
            <div class="column-title">Divisa</div>
            <template v-if="add_ex">
              <div class="column-title">Tipo Cambio</div>
              <div class="column-title">Total Moneda Loc.</div>
            </template>
            <div class="column-title">Tipo gasto</div>
            <div class="column-title">Descripción XML/Recibo</div>
            <div class="column-title">Comentario Gasto</div>
            <template v-if="add_tip">
              <div class="column-title">Archivo Propina</div>
              <div class="column-title">Monto Propina</div>
              <div class="column-title">Descripción propina</div>
              <div class="column-title">Comensales</div>
            </template>
          </div>

            <div v-for="(idx,sol) in solicitudes" :key="idx">
              <solicitud :ref="'sol_'+idx" :_id="idx" :idx="sol+1" :values_forma_solicitud="values_forma_solicitud" :cuentas="cuentas" :divisas="divisas" :deudor="id_deudor" :deudor_original="id_deudor_original"  :add_empty="add_ex" :add_empty_tip="add_tip" :error_prop="errores_multi[idx]" @updated="check" @error="show_error" @del="eliminar_sol" />
            </div>
            
            <div class="opt-hover left">
                <v-icon color="black" @click="addsolicitud">mdi-plus</v-icon>   
            </div>
  
        </div>
        <div class="fila-container mt-10">
          <v-btn @click="enviarTodo" :disabled="disabled_button">Enviar</v-btn>          
          <v-btn class="ml-5" @click="reset">Reset</v-btn>
        </div>

      

        <v-dialog v-model="dialog_group_form" width="60%">
            <v-card>
            <v-card-title
                ><span class="headline">Crear un grupo</span></v-card-title
            >
            <v-card-text>
                <v-form ref="form_grupo">
                <v-row>
                    <v-text-field
                    v-model="nombre_grupo"
                    label="Nombre del grupo"
                    :rules="[(v) => !!v || 'Escriba un nombre del grupo']"
                    ></v-text-field>
                </v-row>
                <v-row>
                    <v-textarea
                    v-model="descripcion_grupo"
                    label="Descripcion del grupo"
                    ></v-textarea>
                </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog_group_form = false"
                >Cancelar</v-btn
                >
                <v-btn
                color="blue darken-1"
                text
                @click="create_grupo"
                :disabled="is_waiting"
                >
                <label v-if="!is_waiting">Guardar</label>
                <v-progress-circular
                    small
                    indeterminate
                    color="primary"
                    v-if="is_waiting"
                    :size="20"
                ></v-progress-circular>
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Form requesting xml file -->
        <!-- <div v-if="locacion_solicitud === 1 && forma_solicitud === 1">
            <v-form ref="form">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-file-input
                    accept="text/xml"
                    label="Favor de subir el archivo XML de la factura"
                    v-model="solicitud.archivo"
                    :rules="[
                    (value) =>
                        !value || value.size > 0 || 'Suba un archivo valido',
                    ]"
                    required
                    @change="analize_xml"
                ></v-file-input>
                <div v-if="mostrar_cargar">
                    <v-progress-circular
                    indeterminate
                    color="primary"
                    ></v-progress-circular>
                    Cargando y validando datos...
                </div>
                <div v-if="mostrar_error_xml">
                    <p class="red--text">{{ texto_error }}</p>
                </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-file-input
                    accept="application/pdf"
                    label="(Opcional) Favor de subir el archivo PDF de la factura"
                    v-model="solicitud.anexo_cfdi"
                    :rules="[
                    (value) =>
                        !value || value.size > 0 || 'Suba un archivo valido',
                    ]"
                    required
                ></v-file-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" md="6">
                <v-select
                    prepend-icon="mdi-account"
                    v-model="solicitud.id_deudor"
                    :items="deudores"
                    item-text="nombre"
                    item-value="id_user"
                    label="Deudor"
                    :readonly="readonlydeudor"
                    filled
                    @change="onchange"
                ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                <v-text-field
                    prepend-icon="mdi-calendar"
                    label="Fecha de Solicitud"
                    v-model="solicitud.fecha_solicitud"
                    data-date-format="mm-dd-yyyy"
                    readonly
                    filled
                ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="4" md="4">
                <v-text-field
                    prepend-icon="mdi-currency-usd"
                    label="Importe"
                    v-model="solicitud.total"
                    readonly
                    filled
                ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                <v-select
                    :items="divisas"
                    item-text="divisa"
                    item-value="id_divisa"
                    prepend-icon="mdi-cash-usd-outline"
                    label="Divisa"
                    v-model="solicitud.id_divisa"
                    readonly
                    filled
                ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                <v-select
                    :items="cuentas"
                    item-text="nombre_cuenta"
                    item-value="id_cuenta"
                    prepend-icon="mdi-badge-account-horizontal-outline"
                    label="Tipo Gasto"
                    v-model="solicitud.id_cuenta"
                    @change="show_anexo_form"
                    :rules="[(v) => !!v || 'Seleccione una cuenta']"
                    required
                ></v-select>
                </v-col>
            </v-row>
            <div v-if="requiere_descripcion">
                <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Comentarios"
                    v-model="solicitud.comentarios"
                    ></v-textarea>
                </v-col>
                </v-row>
            </div>
            <div v-if="propina">
                <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-file-input
                    accept="application/pdf, image/png, image/jpeg"
                    label="Favor de subir el archivo de la propina"
                    v-model="solicitud.archivo_propina"
                    :rules="[
                        (value) =>
                        !value || value.size > 0 || 'Suba un archivo valido',
                    ]"
                    ></v-file-input>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field
                    type="number"
                    prepend-icon="mdi-currency-usd"
                    label="Monto Propina"
                    v-model="solicitud.propina"
                    :rules="[(v) => !!v || 'Escriba el monto de la propina']"
                    required
                    ></v-text-field>
                </v-col>
                </v-row>
                <v-row v-if="descripcion_propina">
                <v-col cols="12" sm="6" md="6">
                    <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Descripción de propina"
                    v-model="solicitud.descripcion_propina"
                    :rules="[(v) => !!v || 'Escriba una descripción']"
                    required
                    ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Comensales"
                    v-model="solicitud.comensales_propina"
                    :rules="[(v) => !!v || 'Escriba los comensales']"
                    required
                    ></v-textarea>
                </v-col>
                </v-row>
            </div>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Descripción"
                    v-model="solicitud.descripcion"
                    readonly
                    filled
                ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-checkbox
                v-model="checkbox_grupo"
                label="Agregar la solicitud a un grupo?"
                ></v-checkbox>
            </v-row>
            <v-row v-if="checkbox_grupo">
                <v-col cols="12" sm="8" md="8">
                <v-select
                    prepend-icon="mdi-account-box-multiple"
                    label="Grupos"
                    :items="grupos"
                    item-value="id_grupo"
                    item-text="nombre"
                    v-model="solicitud.id_grupo"
                ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                <v-btn @click="show_form_group">Agregar un nuevo grupo</v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-btn class="mr-4" @click="submit_xml" :disabled="is_waiting">
                    <label v-if="!is_waiting">Enviar</label>
                    <v-progress-circular
                    :size="20"
                    indeterminate
                    color="primary"
                    v-if="is_waiting"
                    ></v-progress-circular>
                </v-btn>
                <v-btn @click="reset">Cancelar</v-btn>
                </v-col>
            </v-row>
            </v-form>
        </div> -->

        <!-- Form requesting pdf/jpg file -->
        <v-form
            v-if="
          false
            "
            ref="form_pdf"
        >
        
            <v-col cols="2">
                <v-file-input
                accept="application/pdf, image/png, image/jpeg"
                label="Favor de subir el archivo .pdf/.jpg de la factura"
                v-model="solicitud_sin_factura.archivo"
                :rules="[
                    (value) => !value || value.size > 0 || 'Suba un archivo valido',
                ]"
                required
                ></v-file-input>
            </v-col>
      
    
            <v-col cols="1">
                <v-select
                prepend-icon="mdi-account"
                v-model="solicitud_sin_factura.id_deudor"
                :items="deudores"
                item-text="nombre"
                item-value="id_user"
                label="Deudor"
                :readonly="readonlydeudor"
                filled
                @change="onchange"
                ></v-select>
            </v-col>
            <v-col cols="2">
                <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="solicitud_sin_factura.fecha_solicitud"
                    label="Fecha Comprobación"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :rules="[(v) => !!v || 'Seleccione una fecha']"
                    required
                    ></v-text-field>
                </template>
                <v-date-picker
                    :max="new Date().toISOString().slice(0, 10)"
                    v-model="solicitud_sin_factura.fecha_solicitud"
                    no-title
                    @input="menu2 = false"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-text-field
                prepend-icon="mdi-text-short"
                label="Número de Factura"
                v-model="solicitud_sin_factura.numero_factura"
                :rules="[(v) => !!v || 'Escriba el número de factura']"
                required
                ></v-text-field>
            </v-col>
         
            <v-row>
            <v-col cols="12" sm="3" md="3">
                <v-text-field
                type="number"
                prepend-icon="mdi-currency-usd"
                label="Importe"
                v-model="solicitud_sin_factura.total"
                :rules="[(v) => !!v || 'Escriba el total']"
                required
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-select
                :items="divisas"
                item-text="divisa"
                item-value="id_divisa"
                prepend-icon="mdi-cash-usd-outline"
                label="Divisa"
                v-model="solicitud_sin_factura.id_divisa"
                :rules="[(v) => !!v || 'Seleccione una divisa']"
                required
                ></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field
                type="number"
                prepend-icon="mdi-currency-usd"
                label="Tipo Cambio"
                v-model="solicitud_sin_factura.monto_cambio"
                :rules="[(v) => !!v || 'Escriba el monto de cambio']"
                required
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-text-field 
                type="number" 
                prepend-icon="mdi-currency-usd"
                label="Importe Moneda Nacional"
                disabled
                :value="solicitud_sin_factura.monto_cambio*solicitud_sin_factura.total"
                >
                </v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="6">
                <v-select
                :items="cuentas"
                item-text="nombre_cuenta"
                item-value="id_cuenta"
                prepend-icon="mdi-badge-account-horizontal-outline"
                label="Tipo Gasto"
                v-model="solicitud_sin_factura.id_cuenta"
                @change="necesita_propina"
                :rules="[(v) => !!v || 'Seleccione una cuenta']"
                required
                ></v-select>
            </v-col>
            </v-row>
            <div v-if="requiere_descripcion_pdf">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Comentarios"
                    v-model="solicitud_sin_factura.comentarios"
                ></v-textarea>
                </v-col>
            </v-row>
            </div>
            <div v-if="propina_pdf">
            <v-row>
                <v-col cols="12" sm="6" md="6">
                <v-file-input
                    accept="application/pdf, image/png, image/jpeg"
                    label="Favor de subir el archivo de la propina"
                    v-model="solicitud_sin_factura.archivo_propina"
                    
                ></v-file-input>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                <v-text-field
                    type="number"
                    prepend-icon="mdi-currency-usd"
                    label="Monto Propina"
                    v-model="solicitud_sin_factura.propina"

                ></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="descripcion_propina_pdf">
                <v-col cols="12" sm="6" md="6">
                <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Descripción de propina"
                    v-model="solicitud_sin_factura.descripcion_propina"
                    
                ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                <v-textarea
                    prepend-icon="mdi-text-subject"
                    label="Comensales"
                    v-model="solicitud_sin_factura.comensales_propina"
                    
                ></v-textarea>
                </v-col>
            </v-row>
            </div>
            <v-row>
            <v-col cols="12" sm="12" md="12">
                <v-textarea
                prepend-icon="mdi-text-subject"
                label="Descripción"
                v-model="solicitud_sin_factura.descripcion"
                :rules="[(v) => !!v || 'Escriba una descripción']"
                required
                ></v-textarea>
            </v-col>
            </v-row>
            <v-row>
            <v-checkbox
                v-model="checkbox_grupo"
                label="Agregar la solicitud a un grupo?"
            ></v-checkbox>
            </v-row>
            <v-row v-if="checkbox_grupo">
            <v-col cols="12" sm="8" md="8">
                <v-select
                prepend-icon="mdi-account-box-multiple"
                label="Grupos"
                :items="grupos"
                item-value="id_grupo"
                item-text="nombre"
                v-model="solicitud_sin_factura.id_grupo"
                ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-btn @click="show_form_group">Agregar un nuevo grupo</v-btn>
            </v-col>
            </v-row>
            <v-row>
            <v-col class="d-flex" cols="12" sm="12">
                <v-btn class="mr-4" @click="submit_pdf" :disabled="is_waiting"
                ><label v-if="!is_waiting">Enviar</label>
                <v-progress-circular
                    :size="20"
                    indeterminate
                    color="primary"
                    v-if="is_waiting"
                ></v-progress-circular
                ></v-btn>
                <v-btn @click="reset_pdf">Cancelar</v-btn>
            </v-col>
            </v-row>
        </v-form>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
import router from "../router/index.js";
import solicitud from './components/solicitud.vue';
import _ from "lodash"
export default {
  components:{
    solicitud
  },
    data: () =>{
        return {
            locacion_solicitud: 1,
            forma_solicitud: 1,
            values_forma_solicitud: [
        { id: 1, value: "CFDI" },
        { id: 2, value: "Recibo" },
      ],
      values_tipo_solicitud: [
        { id: 1, value: "Gasto Nacional" },
        { id: 2, value: "Gasto Internacional" },
      ],
            dialog_group_form: false,
            nombre_grupo: '',
            descripcion_grupo: '',
            is_waiting: false,
            solicitud: {},
            solicitud_sin_factura: {},
            deudores: [],
            cuentas: [],
            requiere_descripcion_pdf: false,
            propina:false,
            propina_pdf: false,
            descripcion_propina: "",
            checkbox_grupo: false,
            mostrar_cargar: false,
            mostrar_error_xml: false,
            mostrar_error: false,
            error_multiple: "",
            texto_error: "",
            mostrar_alerta: false,
            descripcion_propina_pdf: false,
            menu2: false,
            grupo_temp: "",
            solicitudes: [],
            id_deudor: "",
            deudor: "",
            id_deudor_original: "",
            errores_multi: [],
            grupos: [],
            selected_id_grupo: "",
            disabled_button: false
        }
    },
  mounted() {
    // Config for axios
    axios.defaults.headers.common["access-token"] = this.$store.state.token;
    axios.interceptors.response.use(function(response) {
      if (response.data.message == "Token inválida") {
        router.push({ name: "login", params: { errorToken: "true" } });
      } else {
        return response;
      }
    });
    // End config for axios
    this.get_cuentas();
    this.get_deudor();
    this.get_divisas();
    this.get_deudores();
  },
  methods: {
    analize_xml() {
      if (this.solicitud.archivo !== null) {
        if (
          this.solicitud.archivo !== undefined &&
          this.solicitud.archivo.size > 0
        ) {
          this.mostrar_error_xml === true
            ? (this.mostrar_error_xml = false)
            : "";
          this.mostrar_cargar = true;
          let form_file = new FormData();
          form_file.append("file", this.solicitud.archivo);
          axios
            .post(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/archivos/analizar",
              form_file
            )
            .then((res) => {
              if(res.data.rfc_receptor!='SME980702916')
              {
                this.texto_error = "La solicitud no fue emitida a Bollore";
                this.mostrar_error_xml = true;
                this.mostrar_cargar = false
                this.is_waiting=true
                return false
              }
              
              axios
                .get(
                  `https://` +
                    process.env.VUE_APP_URL +
                    `:3000/gastos/api/v1/solicitudes/archivos/validarcfdi/${res.data.uuid}/${res.data.rfc_emisor}/${res.data.rfc_receptor}/${res.data.total}/${res.data.divisa}`
                )
                .then((validate_cfdi) => {
                  if (
                    validate_cfdi.data.status ===
                    "solictud no registrada anteriormente"
                  ) {
                    let fecha = res.data.fecha_solicitud.split("/");
                    this.solicitud.subtotal = res.data.subtotal;
                    this.solicitud.total = res.data.total;
                    this.solicitud.iva = res.data.iva;
                    this.solicitud.descripcion = res.data.descripcion;
                    this.solicitud.fecha_solicitud =
                      fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                    this.solicitud.id_divisa = res.data.id_divisa;
                    this.solicitud.id_tipo_archivo_solicitud = this.forma_solicitud;
                    this.solicitud.uuid = res.data.uuid;
                    this.solicitud.rfc_emisor = res.data.rfc_emisor;
                    this.solicitud.rfc_receptor = res.data.rfc_receptor;
                    this.solicitud.serie_xml = res.data.serie;
                    this.solicitud.descuento =
                      res.data.descuento != undefined ? res.data.descuento : 0;
                    this.solicitud.otrosimpuestos =
                      res.data.otrosimpuestos != undefined
                        ? res.data.otrosimpuestos
                        : 0;
                    this.solicitud.totalImpuestosTraslados =
                      res.data.totalImpuestosTraslados != undefined
                        ? res.data.totalImpuestosTraslados
                        : 0;
                  } else {
                    this.texto_error = validate_cfdi.data.status;
                    this.mostrar_error_xml = true;
                  }
                  this.mostrar_cargar = false;
                }).catch(()=>{
                  
                  this.mostrar_cargar = false;
                  this.mostrar_error_xml = true;
                  this.texto_error = "Error consultando el estatus de factura"
                  
                });
            });
        } else {
          if (this.mostrar_error_xml === true) {
            this.mostrar_error_xml = false;
          }
          if (this.mostrar_cargar === true) {
            this.mostrar_cargar = false;
          }
          this.solicitud.fecha_solicitud = "";
          this.solicitud.total = "";
          this.solicitud.id_divisa = null;
          this.solicitud.descripcion = "";
        }
      } else {
        if (this.mostrar_error_xml === true) {
          this.mostrar_error_xml = false;
        }
        if (this.solicitud.fecha_solicitud !== "") {
          this.reset();
        }
        if (this.mostrar_cargar === true) {
          this.mostrar_cargar = false;
        }
      }
    },
    show_anexo_form() {

      var obj_selected = this.cuentas.filter((obj) => {
        return obj.id_cuenta === this.solicitud.id_cuenta;
      });
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.propina = true;
      } else {
        this.propina = false;
      }
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripcion_propina = true;
      } else {
        this.descripcion_propina = false;
      }
      if (obj_selected[0]["requiere_descripcion"] === true) {
        this.requiere_descripcion = true;
      } else {
        this.requiere_descripcion = false;
      }
    },
    show_form_group() {
      this.dialog_group_form = true;
      if (this.$refs.form_grupo) {
        this.$refs.form_grupo.reset();
      }
    },
    get_grupos() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/grupos/" +
            this.get_deudor_actual()
        )
        .then((res) => {
          this.grupos = res.data;
        });
    },
    async create_grupo() {
      if (this.$refs.form_grupo.validate()) {
        this.is_waiting = true;
        var grupo = [
          {
            nombre_grupo: this.nombre_grupo,
            descripcion_grupo: this.descripcion_grupo,
            id_deudor: this.get_deudor_actual(),
          },
        ];

        this.grupo_temp=grupo[0].nombre_grupo
        try {
          await axios
            .post(
              "https://" +
                process.env.VUE_APP_URL +
                ":3000/gastos/api/v1/grupos",
              grupo
            )
           
              this.get_grupos();
              this.dialog_group_form = false;
              this.is_waiting = false;
            
        } catch (error) {
          this.is_waiting = false;
          this.dialog_group_form = false;
        }
      }
    },
    get_deudor_actual() {
      var deudor = "";
      if (this.locacion_solicitud === 1 && this.forma_solicitud === 1) {
        deudor = this.solicitud.id_deudor;
      }
      if (
        this.locacion_solicitud === 2 ||
        (this.locacion_solicitud === 1 && this.forma_solicitud === 2)
      ) {
        deudor = this.solicitud_sin_factura.id_deudor;
      }
      if (this.locacion_solicitud === null || this.forma_solicitud === null) {
        deudor = this.id_deudor_original;
      }
      return deudor;
    },
    create_formdata_solicitud(index,dataform_solicitud,solicitud) {
      //var dataform_solicitud = new FormData();
      dataform_solicitud.append("file_"+index, solicitud.archivo);
      dataform_solicitud.append("file_anexo_cfdi_"+index, solicitud.anexo_cfdi);
      dataform_solicitud.append("id_deudor_"+index, solicitud.id_deudor);
      dataform_solicitud.append("id_deudor_original_"+index, this.id_deudor_original);
      dataform_solicitud.append("total_"+index, solicitud.total);
      if (solicitud.id_tipo_solicitud === 2) {
        dataform_solicitud.append("fecha_solicitud_"+index, solicitud.fecha_solicitud);
      } else {
        let fecha_format = solicitud.fecha_solicitud.split("/");
        dataform_solicitud.append(
          "fecha_solicitud_"+index,
          fecha_format[2] + "-" + fecha_format[1] + "-" + fecha_format[0]
        );
      }
      dataform_solicitud.append(
        "id_tipo_solicitud_"+index,
        solicitud.id_tipo_solicitud
      );
      dataform_solicitud.append("descripcion_"+index, solicitud.descripcion);
      dataform_solicitud.append("subtotal_"+index, solicitud.subtotal);
      dataform_solicitud.append("iva_"+index, solicitud.iva);
      dataform_solicitud.append("id_divisa_"+index, solicitud.id_divisa);
      dataform_solicitud.append("id_cuenta_"+index, solicitud.id_cuenta);
      dataform_solicitud.append("anexo_"+index, solicitud.archivo_propina);
      dataform_solicitud.append(
        "id_locacion_solicitud_"+index,
        this.locacion_solicitud
      );
      dataform_solicitud.append(
        "id_tipo_archivo_solicitud_"+index,
        solicitud.id_tipo_archivo_solicitud
      );
      dataform_solicitud.append("deudor_"+index, this.deudor);
      dataform_solicitud.append("propina_"+index, solicitud.propina);
      dataform_solicitud.append("uuid_"+index, solicitud.uuid);
      dataform_solicitud.append("rfc_emisor_"+index, solicitud.rfc_emisor);
      dataform_solicitud.append("rfc_receptor_"+index, solicitud.rfc_receptor);
      dataform_solicitud.append("monto_cambio_"+index, ((solicitud.monto_cambio!==undefined)?solicitud.monto_cambio:0.0));
      dataform_solicitud.append(
        "descripcion_propina_"+index,
        solicitud.descripcion_propina
      );
      dataform_solicitud.append(
        "comensales_propina_"+index,
        solicitud.comensales_propina
      );
      dataform_solicitud.append(
        "id_forma_solicitud_"+index,
        solicitud.id_forma_solicitud
      );
      dataform_solicitud.append("numero_factura_"+index, solicitud.numero_factura);
      dataform_solicitud.append("serie_xml_"+index, solicitud.serie_xml);
      dataform_solicitud.append("comentarios_"+index, solicitud.comentarios);
      dataform_solicitud.append("id_grupo_"+index, this.selected_id_grupo!=""?this.selected_id_grupo:undefined);
      dataform_solicitud.append("descuento_"+index, solicitud.descuento);
      dataform_solicitud.append("otrosimpuestos_"+index, solicitud.otrosimpuestos);
      dataform_solicitud.append(
        "totalImpuestosTraslados_"+index,
        solicitud.totalImpuestosTraslados
      );
      return dataform_solicitud;
    },
    submit_xml() {
      this.mostrar_alerta = false;
      if (this.$refs.form.validate()) {
        this.is_waiting = true;
        this.solicitud.id_tipo_solicitud = 2;
        this.solicitud.id_locacion_solicitud = 1;
        this.solicitud.id_forma_solicitud = 1;
        this.solicitud.monto_cambio = 0.0;
        this.solicitud.numero_factura = "";
        /*
        if (this.propina) {
          this.solicitud.propina = parseFloat(this.solicitud.total*0.10).toFixed(2);
        }
        */
        var solicitud = this.create_formdata_solicitud(this.solicitud);
        axios
          .post(
            "https://" +
              process.env.VUE_APP_URL +
              ":3000/gastos/api/v1/solicitudes",
            solicitud
          )
          .then(() => {
            //this.result_test = res.data;
            this.reset();
            this.mostrar_alerta = true;
          });
      }
    },
    submit_pdf() {
      this.mostrar_alerta = false;
      if (this.$refs.form_pdf.validate()) {
        this.is_waiting = true;
        this.solicitud_sin_factura.id_tipo_solicitud = 2;
        this.solicitud_sin_factura.id_forma_solicitud = 2;
        this.solicitud_sin_factura.descuento = 0;
        this.solicitud_sin_factura.otrosimpuestos = 0;
        this.solicitud_sin_factura.totalImpuestosTraslados = 0;
        this.solicitud.id_locacion_solicitud = 1;
        var iva = parseFloat(
          parseFloat(this.solicitud_sin_factura.total) * 0.16
        );
        var subtotal = parseFloat(this.solicitud_sin_factura.total) - iva;
        iva = iva.toFixed(2);
        subtotal = subtotal.toFixed(2);
        /*
        if (this.propina_pdf===true) {
          this.solicitud_sin_factura.propina = parseFloat(this.solicitud_sin_factura.total*0.10).toFixed(2);
        }
        */
        this.solicitud_sin_factura.iva = iva;
        this.solicitud_sin_factura.subtotal = subtotal;
        this.solicitud_sin_factura.id_tipo_archivo_solicitud = 2;
        var solicitud = this.create_formdata_solicitud(
          this.solicitud_sin_factura
        );
        axios
          .post(
            "https://" +
              process.env.VUE_APP_URL +
              ":3000/gastos/api/v1/solicitudes",
            solicitud
          )
          .then(() => {
            this.reset_pdf();
            this.mostrar_alerta = true;
          });
      }
    },
    get_cuentas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/cuentas"
        )
        .then((res) => {
          this.cuentas = res.data;
        });
    },
    get_deudor() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/usuarios/" +
            this.$store.state.token
        )
        .then((res) => {
          this.deudor = res.data.nombre;
          this.solicitud.id_deudor = res.data.id_user;
          this.deudor_original = res.data.id_user;
          this.id_deudor=res.data.id_user;
          this.id_deudor_original=res.data.id_user;
          this.solicitud_sin_factura.id_deudor = res.data.id_user;
          this.get_grupos();
        });
    },
    get_deudores() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/select/empleados/comprobacion2/" +
            this.$store.state.user.id_puesto
        )
        .then((res) => {
          this.deudores = res.data;
          if (res.data.length <= 1) {
            this.readonlydeudor = true;
          }
        });
    },
    onchange(key) {
      this.deudores.forEach((element) => {
        if (element.id_user == key) {
          this.deudor = element.nombre;
        }
      });
      this.get_grupos();
    },
    get_divisas() {
      axios
        .get(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/catalogos/divisas"
        )
        .then((res) => {
          this.divisas = res.data;
        });
    },
    reset() {
      this.nombre_grupo= ""
      for(const i of this.solicitudes)
      {
      
        if(this.$refs["sol_"+i]!=undefined)
        {
          if(this.$refs["sol_"+i][0].$refs.form!==undefined)
          {
            this.$refs["sol_"+i][0].$refs.form.reset()
            this.$refs["sol_"+i][0].reset()
          }
            
          
          if(this.$refs["sol_"+i][0].$refs.form_pdf!==undefined)
          {
            this.$refs["sol_"+i][0].$refs.form_pdf.reset()
            this.$refs["sol_"+i][0].reset_pdf()
          }
            
        }
      }

      this.get_deudor();
      this.errores_multi=[]
      // this.mostrar_cargar = false;
      // this.propina = false;
      // this.descripcion_propina = false;
      // this.requiere_descripcion = false;
      // this.is_waiting = false;
      this.check()
    },
    reset_pdf() {
      this.$refs.form_pdf.reset();
      this.get_deudor();
      this.propina_pdf = false;
      this.descripcion_propina_pdf = false;
      this.requiere_descripcion_pdf = false;
      this.is_waiting = false;
    },
    necesita_propina() {
      var obj_selected = this.cuentas.filter((obj) => {
        return obj.id_cuenta === this.solicitud_sin_factura.id_cuenta;
      });
      if (obj_selected[0]["requiere_anexo"] === true) {
        this.propina_pdf = true;
      } else {
        this.propina_pdf = false;
      }
      if (obj_selected[0]["es_anexo_comida"] === true) {
        this.descripcion_propina_pdf = true;
      } else {
        this.descripcion_propina_pdf = false;
      }
      if (obj_selected[0]["requiere_descripcion"] === true) {
        this.requiere_descripcion_pdf = true;
      } else {
        this.requiere_descripcion_pdf = false;
      }
    },
    show_columns(params) {
      try {
        this.propina=params
      } catch (error) {
        null
      }
    },
    addsolicitud: function() {
      try {


        this.solicitudes.push(_.uniqueId())
        

      } catch (error) {
        null
      }
    }
    ,
    check: async function(){
      this.solicitudes.push(1)
      this.solicitudes.pop()
    },
    enviarTodo: async function(){
      try {
        this.disabled_button = true
        const dataframes=[]
        let errors = ""
        let aux =1
        for(const i of this.solicitudes)
        {
          let valido_sol = true
          
          if(this.$refs["sol_"+i]!=undefined)
          {
            let forma_sol=this.$refs["sol_"+i][0].forma_solicitud
            if(forma_sol==1)
            {
              const formu = this.$refs["sol_"+i][0].$refs["form"]
              valido_sol = this.$refs["sol_"+i][0].$refs["form"].validate()

              let limit = 11
              if(formu.$el[8].value == ""){
                limit = 9
              }
          
              let campos = "Campos: "
              for(let idx = 0;idx < limit; idx++)
              {
                
                if(!formu.$el[idx].validity.valid)
                {
                   campos += formu.$el[idx].name+ ", "
                }else if (idx == 8){
                  if(formu.$el[idx].value == "")
                  {
                    campos += formu.$el[idx].name+ "Tipo Gasto, "
                  }
                }
              

              }
              if(campos !== "Campos: ")
              {
                errors += " Error en factura # "+aux+" "+campos
              }
            }
            else{
              const formu = this.$refs["sol_"+i][0].$refs["form_pdf"]
              valido_sol = this.$refs["sol_"+i][0].$refs["form_pdf"].validate()
              let campos = "Campos: "
              for(let idx = 0;idx < 9; idx++)
              {
                if(idx == 1)
                {
                  if(formu.$el[idx].value == "")
                  {
                    campos += "Fecha Solicitud, "
                  }
                }

                if(idx == 7)
                {
                  if(formu.$el[idx].value == "")
                  {
                    campos += "Tipo de Gasto, "
                  }
                }

                if(!formu.$el[idx].validity.valid)
                {
                   campos += formu.$el[idx].name+ ", "
                }

              }
              if(campos !== "Campos: ")
              {
                errors += " Error en factura # "+aux+" "+campos
              }
            }
          }

          if(valido_sol==false)
          {

            this.mostrar_error=false
            this.mostrar_error=true
            this.error_multiple= errors
            this.errores_multi[i]=true
            setTimeout(() =>{
              this.mostrar_error=false
            },10000)
            
          }else{
            this.errores_multi[i]=false
          }
          aux += 1
        }

        const break_it =this.errores_multi.reduce((accumulator, currentValue) => accumulator || currentValue)

        if(break_it)
        {
          this.disabled_button = false
          return 
        }
          
          
        for(const i of this.solicitudes)
        {
          
          if(this.$refs["sol_"+i]!=undefined)
          {
            let forma_sol=this.$refs["sol_"+i][0].forma_solicitud
            let fd=null
            if(forma_sol==1)
              fd=this.$refs["sol_"+i][0].submit_xml()
            else
              fd=this.$refs["sol_"+i][0].submit_pdf()
            
            dataframes.push(fd)  
          
          }
        }
        
        const fds=new FormData()
        for(const idx in dataframes)
        {
          this.create_formdata_solicitud(idx,fds,dataframes[idx])
        }
        fds.append("num_sol",dataframes.length)
        fds.append("descripcion",this.nombre_grupo)
        
        await axios.post(
          "https://" +
            process.env.VUE_APP_URL +
            ":3000/gastos/api/v1/multi_solicitudes",
          fds
        )
        
        this.reset()
        this.nombre_grupo= ""
        this.errores_multi=[]
        this.mostrar_alerta = true;
        this.solicitudes=[]
        this.disabled_button = false
      
      } catch (error) {
        this.disabled_button = false
        this.mostrar_error=true
        this.error_multiple= "Error enviando las solicitudes"
       
      }
    },
    show_error: function(payload){
      this.mostrar_error=false
      this.mostrar_error=true
        this.error_multiple= payload
    },
    eliminar_sol: async function(idx){

      const last=_.indexOf(this.solicitudes,idx)
     
      this.solicitudes.splice(last,1)
      
      delete this.errores_multi[idx]
      delete this.$refs["sol_"+idx]


    }
  },
  computed: {
    add_ex: function (){
     

      let need_ex=false

      for(const i of this.solicitudes)
      {

        if(this.$refs["sol_"+i]!=undefined)
          if(this.$refs["sol_"+i][0]!==undefined)
          if(this.$refs["sol_"+i][0]['foreign_ex']!==false)
          {
            need_ex=true
          }
        
      }

      return need_ex
    },
    add_tip: function(){

      let need_columns=false

      for(const i of this.solicitudes)
      {
     
        if(this.$refs["sol_"+i]!=undefined)
          if(this.$refs["sol_"+i][0]!==undefined)
          if(this.$refs["sol_"+i][0]['propina_column']!==false)
          {
            need_columns=true
          }
        
      }

      return need_columns
    }
  }
  
}
</script>

<style>


  .fila-title{
    position: sticky !important;
    top: 0px;
    z-index: 7;
  }


  .fila-container{
    overflow-x: scroll;
  }
  .fila{
    display: -webkit-box;
    width: 100% ;
    
   
  }

.column-title{
  padding-left: 10px;
    padding-right: 0px;
    width: 15rem !important;
    height: 2rem !important;
    border-style: solid;
    border-width: 1px;
    background-color: darkgrey;
    background-color: #01723a;
    color: white;
    font-weight: bolder;
}

.first{
  width: 3rem !important;
  position: sticky;
  left: 0px;
  z-index: 900;
}

.row-number{

  padding-left: 0px; 
  text-align: center;
  padding-top: 1.2rem;
  height: 5rem !important;
  background-color: #01723a;
  color: white;
  font-weight: bolder;
}
  .column{
    padding-left: 10px;
    padding-right: 0px;
    width: 15rem !important;
    height: 5rem !important;
    border-style: solid;
    border-width: 1px;
    
  }


  .group-col{
    display: inline-flex;
  }
  

  .fila-container > .fila:nth-child(even) > .group-col .column{
    background-color:aliceblue;
  }
  


.fila-container .opt-hover.left{
  display: none;
  border-radius: 50rem;
  background-color: greenyellow;
}



.fila-container:hover .opt-hover.left{
  z-index: 999;
  display:flow-root;
  float: left;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bolder;
  position: absolute;
  margin-top : -0.5rem;
  margin-left : 0rem;
}
  .legend{
    position: absolute;
  }
</style>